import React from 'react';
import Filters from '../Filters';
import CsvDropzone from '../CsvDropzone';

export default function CallFiltersPanel({ csvData, filters, setFilters, fileName, onParsed, onDelete }) {
  return (
    <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'flex-start' }}>
      {csvData.length > 0 && (
        <Filters data={csvData} filters={filters} setFilters={setFilters} />
      )}
      <CsvDropzone onParsed={onParsed} fileName={fileName} onDelete={onDelete} />
    </div>
  );
}
